import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { getRevealProps } from '../motion/scrollMotion';
import ScrollReveal from './ScrollReveal';
import './CaseStudiesSection.css';

const CaseStudiesSection = () => {
  return (
    <ScrollReveal as="section" className="case-studies-section" id="base-studies" variant="fadeUp">
      <div className="cs-container">
        <div className="cs-header">
          <motion.h2 className="cs-main-title" {...getRevealProps('fadeUp')}>
            Trusted by Organizations That Take Security Seriously
          </motion.h2>
          <motion.p className="cs-subtitle" {...getRevealProps('fadeUp', 0.12)}>
            From financial services and healthcare to SaaS platforms and government agencies,
            mid-market and enterprise organisations partner with Proven InfoSec to protect critical
            assets, maintain operational stability, and build secure digital products.
          </motion.p>
          <motion.div {...getRevealProps('scaleUp', 0.22)}>
            <Link to="/customers" className="cs-read-more">
              Read More Case Studies
            </Link>
          </motion.div>
        </div>

        <div className="cs-content-grid">
          <motion.div className="cs-stats-column" {...getRevealProps('slideLeft')}>
            <div className="cs-stat-card">
              <h3 className="cs-stat-value">500+ engagements</h3>
              <p className="cs-stat-desc">delivered across cybersecurity, IT operations, and secure development</p>
            </div>
            <div className="cs-stat-card">
              <h3 className="cs-stat-value">99.9% uptime</h3>
              <p className="cs-stat-desc">delivered for managed IT clients with 24/7 SOC monitoring</p>
            </div>
            <div className="cs-stat-card">
              <h3 className="cs-stat-value">100% certified</h3>
              <p className="cs-stat-desc">CISSP, CEH, OSCP, CISA, and ISO 27001-certified security professionals on every engagement</p>
            </div>
          </motion.div>

          <motion.div className="cs-visual-column" {...getRevealProps('slideRight', 0.1)}>
            <div className="cs-visual-card">
              <img
                src="/board.png.png"
                alt="Corporate Meeting"
                className="cs-visual-img"
              />
              <div className="cs-visual-overlay">
                <div className="cs-visual-logo">Infrastructure</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </ScrollReveal>
  );
};

export default CaseStudiesSection;
